export default __webpack_public_path__ + "static/media/Camera Image, Grey.c6ed443c.png";